import { getApiBaseUrl, platform } from '../config/runtime';

export async function loadBranding() {
  try {
    let url = '/config/branding.json';
    if (platform.isNative()) {
      const apiBase = getApiBaseUrl().replace(/\/+$/, '');
      const origin = apiBase.replace(/\/api$/, '');
      url = `${origin}/config/branding.json`;
    }
    const res = await fetch(url, { cache: 'no-cache' });
    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (_) {
    return null;
  }
}


